<template>
  <div>
    <div>
      <div class="tips">审核人调整</div>
      <div class="clearfix rlr">
        <div class="label">审核人</div>
        <div class="input">
          <treeselect
            v-model="rlReviewers"
            :multiple="true"
            placeholder="请选择"
            :options="deptUser"
            :disable-branch-nodes="true"
            :show-count="true"
            value-consists-of="LEAF_PRIORITY"
            no-results-text="未搜到任何结果"
            :clear-on-select="true"
            :normalizer="normalizer"
            style="width: 100%"
            size="small"
          />
        </div>
      </div>
    </div>
    <div>
      <div class="tips">认领历史</div>
      <el-table
        :max-height="height"
        :data="rlHistorys"
        fit
        highlight-current-row
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="认领人"
          align="left"
          prop="rlr"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="评审人/状态/时间"
          align="left"
          prop="audit"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-html="scope.row.audit"></div>
          </template>
        </el-table-column>
        <el-table-column
          label="认领时间"
          align="left"
          prop="rltime"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="审核意见"
          align="left"
          prop="bz"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-html="scope.row.bz"></div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
    </div>
  </div>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { getTaskrkshtz, saveTaskRlConfig } from "@/api/task.js";

export default {
  name: "taskClaimSetting",
  computed: { ...mapGetters(["deptUser", "task"]) },
  components: { Treeselect },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      rlHistorys: [],
      rlReviewers: [],
      parentDialog: false,
    };
  },
  created() {
    getTaskrkshtz({ taskId: this.mxParams.id, type: 2 }).then((res) => {
      if (res.code == 0) {
        this.rlHistorys = res.data.rlHistorys;
      }
    });
  },
  methods: {
    saveForm() {
      if (this.rlReviewers.length == 0) {
        this.$message.error("审核人不能为空！");
        return;
      }
      let params = {
        ygbhs: this.rlReviewers.toString(),
        taskId: this.mxParams.id,
      };
      saveTaskRlConfig(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$store.dispatch(
            "task/fetchTaskListAction",
            this.task.taskList.params
          );
          this.$emit("giveFather", this.parentDialog);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    giveFather() {
      this.parentDialog = false;
    },
  },
};
</script>
<style lang="less" scoped>
.tips {
  background-color: #d7d7d7;
  height: 44px;
  line-height: 44px;
  padding-left: 15px;
  margin: 15px 0;
}
.rlr {
  display: flex;
  .label {
    width: 80px;
    line-height: 40px;
    text-align: right;
    padding-right: 10px;
  }
  .input {
    width: calc(100% - 80px);
  }
}
</style>